import { defineComponent as _defineComponent } from 'vue'
import { withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { h, useSlots, reactive } from "vue";
      import { assignSlotNodes, Slots } from "@lit-labs/vue-utils/wrapper-utils.js";
      import '@oicl/openbridge-webcomponents/dist/ar/poi-card-header/poi-card-header.js';
      import {ObcPoiCardHeaderVariant} from '@oicl/openbridge-webcomponents/dist/ar/poi-card-header/poi-card-header.js';

      export interface Props {
     variant?: ObcPoiCardHeaderVariant;
     index?: string;
     cardTitle?: string;
     description?: string;
     source?: string;
     timestamp?: string;
     hasLeadingIcon?: boolean;
     hasCloseButton?: boolean
   }

      
  
      export type {ObcPoiCardHeaderVariant} from '@oicl/openbridge-webcomponents/dist/ar/poi-card-header/poi-card-header.js';
    
export default /*@__PURE__*/_defineComponent({
  __name: 'ObcPoiCardHeader',
  props: {
    variant: {},
    index: {},
    cardTitle: {},
    description: {},
    source: {},
    timestamp: {},
    hasLeadingIcon: { type: Boolean },
    hasCloseButton: { type: Boolean }
  },
  emits: ["close-click"],
  setup(__props: any, { emit: __emit }) {

      const vueProps = __props;

  const defaults = reactive({} as Props);
  const vDefaults = {
    created(el: any) {
      for (const p in vueProps) {
        defaults[p as keyof Props] = el[p];
      }
    }
  };

  let hasRendered = false;

      const emit = __emit;

      const slots = useSlots() as Slots;

      const render = () => {
        const eventProps = {
    onCloseClick: (event: CustomEvent<void>) => emit('close-click', event as CustomEvent<void>)
  };
        const props = eventProps as (typeof eventProps & Props);

        
      for (const p in vueProps) {
        const v = vueProps[p as keyof Props];
        if ((v !== undefined) || hasRendered) {
          (props[p as keyof Props] as unknown) = v ?? defaults[p as keyof Props];
        }
      }

      hasRendered = true;
    

        return h(
          'obc-poi-card-header',
          props,
          assignSlotNodes(slots)
        );
      };
    
return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createBlock(render, null, null, 512)), [
    [vDefaults]
  ])
}
}

})